import { Tooltip } from "antd";
import { useTheme } from "../cms/utils/theme";

/**
 * The accent swatches, matching the intelligence dashboard's.
 *
 * Both apps write the same key on the same origin, so a choice made here shows
 * up there and the other way round — no request, no setting to keep in step.
 */
const ThemePicker = () => {
  const { theme, setTheme, themes } = useTheme();

  return (
    <div
      className="d-none d-sm-flex align-items-center"
      style={{ gap: 7, padding: "0 12px" }}
      role="radiogroup"
      aria-label="Accent colour"
    >
      {Object.entries(themes).map(([slug, t]) => {
        const on = slug === theme;
        return (
          <Tooltip key={slug} title={t.label}>
            <button
              type="button"
              role="radio"
              aria-checked={on}
              aria-label={t.label}
              onClick={() => setTheme(slug)}
              style={{
                width: 18,
                height: 18,
                borderRadius: "50%",
                background: t.accent,
                cursor: "pointer",
                padding: 0,
                /* The ring sits outside the swatch so the colour itself is never
                   obscured by the thing marking it as chosen. */
                border: "2px solid #fff",
                boxShadow: on
                  ? `0 0 0 2px ${t.accent}`
                  : "0 0 0 1px rgba(0,0,0,.12)",
                transition: "box-shadow .15s ease",
              }}
            />
          </Tooltip>
        );
      })}
    </div>
  );
};

export default ThemePicker;
